import { Pipe, PipeTransform } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';

@Pipe({ name: 'ordinalFormat' })
export class OrdinalFormatPipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  public transform(value: number): string {
    if (value === null || value === undefined) {
      return;
    }

    return this.translateService.instant(`ORDINAL_NUMBERS.${value}`) as string;
  }
}
